import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

import GAMES from '../Games.json';
import GameSequence from './GameSequence.js';

const Game = ({ match }) => (
  <Switch>
    { Object.keys(GAMES).map((key) => (
        <Route
          path={match.url + '/' + key}
          key={key}
          render={() => <GameSequence {...GAMES[key]} /> }
        /> ))}
    <Redirect to='/' />
  </Switch>
);

export default Game;


// WEBPACK FOOTER //
// ./src/components/Game.js